// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React from 'react';
import {
  convertSaleStatusToClassName,
  convertSaleStatusToColor,
} from '../../../utils/convertSaleStatus';
import { AiOutlineClockCircle } from 'react-icons/ai';

import './myCollection.scss';
const maxShowTotalBuy = 9999;
const showTotalBuy = '9999+';

function MyCollection({ collection, onClick, isShowTime = false, isRecommendLottery = false }) {
  return (
    <div className="card-lottery-collection card" onClick={onClick}>
      <div className="card-img-top">
        <div>
          <img src={isRecommendLottery ? collection.image : collection.image.image_url} />
        </div>
      </div>
      <div className="card-body">
        <div
          style={{
            backgroundImage: `url(${convertSaleStatusToClassName(collection.sale_status)})`,
            backgroundSize: '100% 100%',
          }}
          className="sale-status"
        ></div>
        <div className="quantity-item NotoSansJP">
          {collection.total_buy && (
            <div className="quantity-lottery-purchase">
              <p className="text">購入枚数</p>
              <span>
                {collection.total_buy < maxShowTotalBuy ? collection.total_buy : showTotalBuy}{' '}
                <b>枚</b>
              </span>
            </div>
          )}
        </div>
        <div className="card-title mb-0 AOTFShinMaruGoPro">{collection.name}</div>
      </div>
    </div>
  );
}

export default MyCollection;
